import { jsonObject, jsonMember } from 'typedjson';

@jsonObject
export class ChangePasswordRequestModel {
  @jsonMember
  public oldPassword: string;
  @jsonMember
  public newPassword: string;
}
